export default "<h1>Spielbetrieb</h1>\n<h2>Trainer</h2>\n<member-overview-list [roleId]=\"roleId\"></member-overview-list>";